<template>
  <div class="popup" v-show="specialCloudShow" v-cloak>
    <div v-if="cloudInfo" class="content"
      :class="cloudInfo&&(cloudInfo.appName=='gSuite' || cloudInfo.appName=='gSuiteSharedDrive')?'addSpecialCloud':'addOtherSpecialCloud'">
      <div class="title">
        <span> {{$t('language.common.add')}} {{$t("language.addCloud."+cloudInfo.appName)}}</span>
        <div class="icon white-close dialog-close" @click="specialCloudShow=false,cloudInfo=''"></div>
      </div>
      <div class="add-special-cloud-cont">
        <span v-if="cloudInfo&&(cloudInfo.appName=='gSuite' || cloudInfo.appName=='gSuiteSharedDrive')">
          <div v-html="$t('language.popup.addCloudPopup.specialgSuite')"></div>
        </span>
        <span v-if="cloudInfo&&cloudInfo.appName=='dropbox4Business'">
          <div v-html="$t('language.popup.addCloudPopup.specialDropBox')"></div>
        </span>
        <span v-if="cloudInfo&&cloudInfo.appName=='oneDrive4Business'">
          <div v-html="$t('language.popup.addCloudPopup.specialOnedrive')"></div>
        </span>
        <span v-if="cloudInfo&&cloudInfo.appName=='boxBusiness'">
          <div v-html="$t('language.popup.addCloudPopup.specialBoxBusiness')"></div>
        </span>
        <div style="margin-top:20Px;" v-html="$t('language.popup.addCloudPopup.specialDropBoxBottom')"></div>
        <div
          :class="[cloudInfo&&(cloudInfo.appName=='gSuite' || cloudInfo.appName=='gSuiteSharedDrive')?'special-bottom-botton':'special-obottom-botton',cloudInfo&&cloudInfo.appName=='gSuite' && languageArr.includes($i18n.locale)?'special-cbottom-botton':'',cloudInfo&&(cloudInfo.appName=='gSuite' || cloudInfo.appName=='gSuiteSharedDrive')&& otherLanguageArr.includes($i18n.locale)?'special-tbottom-botton':'']">
          <button class="special-botton special-botton-left" @click="addOra(1)">
            <span v-show="leftconnect">{{$t('language.common.connecting')}}
              <span class="cloudDotting"></span>
            </span>
            <span v-show="!leftconnect">
              {{$t('language.popup.addCloudPopup.accessOrganization')}}
            </span>
          </button>
          <button class="special-botton special-botton-right" @click="addOra(2)">
            <span v-show="rightconnect">{{$t('language.common.connecting')}}
              <span class="cloudDotting"></span>
            </span>
            <span v-show="!rightconnect">
              {{$t('language.popup.addCloudPopup.accessPersonalCloud')}}
            </span>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
  import commonstate from '@/js/constant.js';
  import commonUtils from "@/js/workspace/common_util.js";
  export default {
    data: function() {
      return {
        specialCloudShow: false,
        cloudInfo: null,
        reName: null,
        leftconnect: false,
        rightconnect: false,
        languageArr: ['traditionalChinese', 'chinese', ],
        otherLanguageArr: ['english', ]
      }
    },
    methods: {
      addOra(num) {
        let user = commonUtils.getUser();
        var that = this;
        let redirectUrl = commonstate.addCloudRedirectUrl;
        if(this.$route.name == 'emailTransfer'){
                redirectUrl = commonstate.addFromEmailTransRedirectUrl;
            }
        var appName;
        var cs = null;
        var bn = null;
        if (num == 1) {
          appName = this.cloudInfo.appName;
          this.leftconnect = true;
          if(this.cloudInfo.appName == 'oneDrive4Business'){
            cs = "admin";
          }
        } else {
          this.rightconnect = true;
          // 要求gsuite个人入口添加的账户用gsuite图标显示，实际为googledrive授权
          if (this.cloudInfo.appName == 'gSuite') {
            appName = 'google_drive';
            bn = "gSuite";
          } else if (this.cloudInfo.appName == 'gSuiteSharedDrive') {
            appName = 'gSuiteSharedDrive';
            cs = "google";
          } else if (this.cloudInfo.appName == 'dropbox4Business') {
            appName = 'dropbox';
          } else if (this.cloudInfo.appName == 'oneDrive4Business'){
            appName = 'oneDriveV2';
          }else if (this.cloudInfo.appName == 'boxBusiness'){
            appName = 'box';
          }
        }
        this.$forceUpdate();
         let name = this.$t('language.addCloud.' + this.cloudInfo.appName).trim().replace(/\s+/ig, " ");
        let allDrives = Object.assign([], this.$store.getters.getUsersDrives);
        let nameArr = [];
        $.each(allDrives, function(i, item) {
          nameArr.push(item.name);
        });
        commonUtils.includesDriveName(nameArr, name, that);
        var addData = new addCloudUtils.addCloudData(user.id, this.reName, null, null, null, null, null, bn, appName,
          cs, null, redirectUrl);
        //请求后端数据
        this.Utils.doDrivesRequest("add", addData).then(res => {
          var allDrives = Object.assign([], this.$store.getters.getUsersDrives);
          localStorage.setItem(user.id + 'driveNum', allDrives.length); //用户的云盘列表长度
          that.Utils.openWin(res);
          that.specialCloudShow = false;
          that.leftconnect = false;
          that.rightconnect = false;
        });
      },
    }

  }
</script>

<style>
  .addSpecialCloud {
    width: 635px;
    height: 330px;
  }

  .addOtherSpecialCloud {
    width: 635px;
    /*no*/
    height: 280Px;
  }

  .add-special-cloud-cont {
    width: 100%;
    height: calc(100% - 40px);
    /*no*/
    padding: 35px 35px 0px 35px;
    /*no*/
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    align-items: center;
    text-align: left;
    vertical-align: middle;
    position: relative;
  }

  .special-bottom-botton {
    width: 480Px;
    display: flex;
    align-items: center;
    text-align: center;
    vertical-align: middle;
    position: relative;
    top: 40Px;
    margin: 0 auto;
  }

  .special-tbottom-botton {
    width: 480Px;
    display: flex;
    align-items: center;
    text-align: center;
    vertical-align: middle;
    position: relative;
    top: 60Px;
    margin: 0 auto;
  }

  .special-obottom-botton {
    width: 480Px;
    display: flex;
    align-items: center;
    text-align: center;
    vertical-align: middle;
    position: relative;
    top: 40Px;
    margin: 0 auto;
  }

  .special-cbottom-botton {
    width: 480Px;
    display: flex;
    align-items: center;
    text-align: center;
    vertical-align: middle;
    position: relative;
    top: 80Px;
    margin: 0 auto;
  }

  .special-botton {
    width: 220Px;
    height: 35Px;
    border-radius: 5Px;
    margin: 0 auto;
  }

  .special-botton-left {
    color: #fff;
    border: 1Px solid #fff;
    background: #5562b4;
  }

  .special-botton-right,
  .special-botton-right:hover {
    color: #5562b4;
    border: 1Px solid #5562b4;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/add_special_cloud_popup.vue